import React, { useEffect, useRef, useState } from "react";
import { Tag, Tooltip } from "antd";
import { FieldTimeOutlined } from "@ant-design/icons";
import { useConfig } from "../../contexts/ConfigContext";
import { countryMap } from "../../constants/countries";
import { comprobarHuso, zonaDelEquipo } from "../../utils/husoDelEquipo";
import { ultimaHoraDelServidor } from "../../services/relojDelServidor";
import { anotarAviso } from "../../services/syncLog";

// Cada cuánto se vuelve a comprobar. Es barato: no sale a la red, usa la última
// hora de Business Central que ya llegó con cualquier respuesta.
const CADA_CUANTO_MS = 60 * 1000;

/**
 * Avisa si la zona horaria o el reloj del equipo no son los esperados
 * (utils/husoDelEquipo.js). No muestra nada si todo cuadra.
 *
 * El mensaje emergente sale una vez por tipo de aviso mientras el componente
 * siga montado: vuelve a salir al entrar de nuevo a la sesión o al cambiar entre
 * pantalla ancha y móvil, no sin fin. La etiqueta se queda en el encabezado
 * mientras dure el problema, con el detalle al pasar el cursor. En móvil vive
 * dentro del menú desplegable, así que se ve al abrirlo.
 */
const AvisoDeHuso = ({ enMenuMovil = false }) => {
  const { country } = useConfig() || {};
  const [avisos, setAvisos] = useState([]);
  const anunciados = useRef(new Set());

  useEffect(() => {
    const revisar = () => {
      const resultado = comprobarHuso({
        zonaEsperada: countryMap[country?.code]?.timeZone,
        pais: country?.name,
        ahora: Date.now(),
        desfaseDelEquipoMin: -new Date().getTimezoneOffset(),
        zonaDelEquipo: zonaDelEquipo(),
        horaDelServidor: ultimaHoraDelServidor(),
      });

      setAvisos(resultado);

      for (const aviso of resultado) {
        if (anunciados.current.has(aviso.clave)) continue;
        anunciados.current.add(aviso.clave);
        anotarAviso("hora del equipo", aviso.texto);
        window.messageApi?.warning(aviso.texto, 10);
      }
    };

    revisar();
    const intervalo = setInterval(revisar, CADA_CUANTO_MS);
    return () => clearInterval(intervalo);
  }, [country?.code, country?.name]);

  if (avisos.length === 0) return null;

  const etiqueta = (
    <Tooltip
      title={
        <>
          {avisos.map((aviso) => (
            <div key={aviso.clave} style={{ marginBottom: 4 }}>
              {aviso.texto}
            </div>
          ))}
        </>
      }
    >
      <Tag color="warning" icon={<FieldTimeOutlined />} style={{ margin: 0 }}>
        Hora del equipo
      </Tag>
    </Tooltip>
  );

  return enMenuMovil ? <div style={{ marginTop: "8px" }}>{etiqueta}</div> : etiqueta;
};

export default AvisoDeHuso;
